// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__iOF1v","label":"Completed_label__3Gjdm"};